import { DashboardSlaSlot } from "@redotech/redo-fulfillment-operations-common/views/default-outbound-views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const resetDashboardSlaView = {
  name: "resetDashboardSlaView" as const,
  input: z.object({ slot: createEnum(DashboardSlaSlot) }),
  output: z.object({}),
};
